type ListingQueryValue = string | number | boolean | string[] | number[] | boolean[] | undefined

export function normalizeListingQueryState(query: Record<string, ListingQueryValue>) {
  return Object.entries(query)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, value]) => [key, Array.isArray(value) ? [...value] : value] as const)
}
